import graphql from '@/graphql';
import graphqlHelper from '@/services/graphqlHelper';

const getPinCode = () =>
  graphqlHelper({
    query: graphql.catering.queries.getPinCode,
    variables: {},
  });

const getCateringData = ({ office, date }) =>
  graphqlHelper({
    query: graphql.catering.queries.getCateringData,
    variables: {
      office,
      date,
    },
  });

export {
  // eslint-disable-next-line import/prefer-default-export
  getPinCode,
  getCateringData,
};



// WEBPACK FOOTER //
// ./src/services/catering.js